import { Box, Divider, Heading, Flex, Text } from "@chakra-ui/react";
import { PlcGroupsIcon } from "../../assets/icons";
import { useTranslation } from "react-i18next";

const PlcGroup = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Flex align="center" mb={4}>
        <PlcGroupsIcon />
        <Heading as="h1" size="2xl" color="#a2ba06" ml={3}>
          {t("reports.plc_groups.title")}
        </Heading>
      </Flex>

      <Text fontSize="xl" color="gray.500" mb={4}>
        {t("reports.plc_groups.description")}
      </Text>
      <Divider />
    </Box>
  );
};

export default PlcGroup;